/*=========================================================================================
  File Name: moduleAuthGetters.js
  Description: Auth Module Getters

==========================================================================================*/

export default {}
